<template>
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">編輯聯絡資訊<span class="modal-title text-red ml-3">(我已確實取得客戶同意，為客戶進行資料建檔！)</span></h3>
        </div>
        <div class="modal-body" :class="{ 'section-loading': Loading }">
          <form class="form">
            <div class="form-group row">
              <label for="name" class="col-3 text-right">姓名</label>
              <div class="col-9">
                <input type="text" class="form-control form-control-inline" v-model="form.name" alt="ch" maxlength="50"
                  @input="checkInputName" @blur="checkInputName" />
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-3 text-right">原住民姓名(拼音)</label>
              <div class="col-9">
                <input type="text" class="form-control" v-model="form.wg_name" maxlength="100" @input="checkInputWgName"
                  @blur="checkInputWgName" />
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">性別</label>
              <div class="col-9">
                <div class="radio radio-inline">
                  <input type="radio" :name="`${compName}-gender`" :id="`${compName}-gender-1`" value=1
                    v-model="form.gender">
                  <label :for="`${compName}-gender-1`">男</label>
                </div>
                <div class="radio radio-inline">
                  <input type="radio" :name="`${compName}-gender`" :id="`${compName}-gender-2`" value=2
                    v-model="form.gender">
                  <label :for="`${compName}-gender-2`">女</label>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="birth-year" class="col-3 text-right">生日</label>
              <div class="col-9">
                <select id="birth-year" class="form-control form-control-inline" v-model="form.birthdayAry[0]"
                  :class="{ 'is-invalid': isBirdayError }"
                  @change="computeBirAge(form.birthdayAry[0], form.birthdayAry[1], form.birthdayAry[2])">
                  <option value="">請選擇</option>
                  <option v-for="(opt, y_opt_i) in birthYearOpt" :key="`birth-year-${y_opt_i}`" :value="opt">{{ opt -
                    1911 }}年</option>
                </select>
                <span class="text">/</span>
                <select id="birth-month" class="form-control form-control-inline" v-model="form.birthdayAry[1]"
                  :class="{ 'is-invalid': isBirdayError }"
                  @change="computeBirAge(form.birthdayAry[0], form.birthdayAry[1], form.birthdayAry[2])">
                  <option value="">請選擇</option>
                  <option v-for="(opt, m_opt_i) in birthMonthOpt" :key="`birth-month-${m_opt_i}`" :value="opt">{{ opt
                  }}月
                  </option>
                </select>
                <span class="text">/</span>
                <select id="birth-date" class="form-control form-control-inline" v-model="form.birthdayAry[2]"
                  :class="{ 'is-invalid': isBirdayError }"
                  @change="computeBirAge(form.birthdayAry[0], form.birthdayAry[1], form.birthdayAry[2])">
                  <option value="">請選擇</option>
                  <option v-for="(opt, d_opt_i) in birthDateOpt" :key="`birth-date-${d_opt_i}`" :value="opt">{{ opt }}日
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="age" class="col-3 text-right">年齡</label>
              <div class="col-9">
                <input type="text" @input="numberAge" class="form-control form-control-inline" v-model="form.age"
                  :disabled="agedisable" maxlength="3" />
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">ID</label>
              <div class="col-9">
                <div v-if="inputs.ID" class="d-inline-block">
                  <div class="p-2">{{ form.ID }}</div>
                </div>
                <div v-else class="d-inline-block align-top">
                  <input type="text" class="form-control form-control-inline" v-on="checkSexById()" v-model="form.ID"
                    maxlength="10" />
                  <div class="invalid-feedback">
                    Please insert currect ID.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">LINE ID</label>
              <div class="col-9">
                <input type="text" class="form-control form-control-inline" v-model="form.lineid" maxlength="20" />
              </div>
            </div>
            <div v-if="is_same_mobile == false" style="background-color:#FFEEDD;">
              &nbsp;&nbsp;
              <div class="form-group row">
                <label for="gender-1" class="col-3 text-right">手機</label>
                <div class="col-9">
                  <input type="tel" @input="numberMobile" class="form-control form-control-inline" v-model="form.mobile"
                    maxlength="20" />
                </div>
              </div>
              <div class="form-group row">
                <label for="new-mobile-text" class="col-3 text-right"></label>
                <div class="col-9">
                  <div class="checkbox checkbox-inline ">
                    <input type="checkbox" id="new-mobile" v-model="mobile_change" @click="change('mobile')" />
                    <label for="new-mobile" style="color:#F00078;">代入客戶留存最新手機：{{ addressData.mobile01 }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="form-group row">
                <label for="gender-1" class="col-3 text-right">手機</label>
                <div class="col-9">
                  <input type="tel" @input="numberMobile" class="form-control form-control-inline" v-model="form.mobile"
                    maxlength="20" />
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">住家電話</label>
              <div class="col-9">
                <input type="tel" @input="numberPhone0" class="form-control form-control-inline form-short"
                  v-model="form.phone[0]" maxlength="5" />
                <span class="text">-</span>
                <input type="tel" @input="numberPhone1" class="form-control form-control-inline" v-model="form.phone[1]"
                  maxlength="20" />
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">公司電話</label>
              <div class="col-9">
                <input type="tel" @input="numberOffice_phone0" class="form-control form-control-inline form-short"
                  v-model="form.office_phone[0]" maxlength="5" />
                <span class="text">-</span>
                <input type="tel" @input="numberOffice_phone1" class="form-control form-control-inline"
                  v-model="form.office_phone[1]" maxlength="15" />
                <span class="text">#</span>
                <input type="tel" @input="numberOffice_phone2" class="form-control form-control-inline form-short"
                  v-model="form.office_phone[2]" maxlength="10" />
              </div>
            </div>
            <div v-if="is_same_address == false" style="background-color:#FFEEDD;">
              &nbsp;&nbsp;
              <div class="form-group row">
                <label for="gender-1" class="col-3 text-right">現居地址</label>
                <div class="col-9">
                  <select class="form-control form-control-inline" v-model="form.address[1]"
                    @change="changeCity(form.address[1], form.address[2].name, 'address')"
                    :class="{ 'is-invalid': Check_city }">
                    <option value="">請選擇</option>
                    <option v-for="(city, cid) in cityOpt" :key="`city-item-${cid}`" :value="city">{{ city }}</option>
                  </select>

                  <select class="form-control form-control-inline form-medium" v-model="form.address[0]"
                    :disabled="form.address[1] == ''" @change="changeArea($event, 'address')"
                    :class="{ 'is-invalid': Check_area }">
                    <option value="">請選擇</option>
                    <option v-for="(area, aid) in areaOpt" :key="`area-item-${aid}`" :value="area.no">{{ area.name }}
                    </option>
                  </select>
                  <input type="text" class="form-control form-control-inline" :class="{ 'is-invalid': Check_address }"
                    v-model="form.address[3]" alt="ch" maxlength="50" @input="checkInputAddress"
                    @blur="checkInputAddress" />
                </div>
              </div>
              <div class="form-group row">
                <label for="new-address-text" class="col-3 text-right"></label>
                <div class="col-9">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id="new-address" @click="change('address')" v-model="address_change" />
                    <label for="new-address" style="color:#F00078;">代入客戶留存最新現居地址：{{ addressData.feeAdd |
                      addressFormat }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="form-group row">
                <label for="gender-1" class="col-3 text-right">現居地址</label>
                <div class="col-9">
                  <select class="form-control form-control-inline" v-model="form.address[1]"
                    @change="changeCity(form.address[1], form.address[2].name, 'address')"
                    :class="{ 'is-invalid': Check_city }">
                    <option value="">請選擇</option>
                    <option v-for="(city, cid) in cityOpt" :key="`city-item-${cid}`" :value="city">{{ city }}</option>
                  </select>

                  <select class="form-control form-control-inline form-medium" v-model="form.address[0]"
                    :disabled="form.address[1] == ''" @change="changeArea($event, 'address')"
                    :class="{ 'is-invalid': Check_area }">
                    <option value="">請選擇</option>
                    <option v-for="(area, aid) in areaOpt" :key="`area-item-${aid}`" :value="area.no">{{ area.name }}
                    </option>
                  </select>
                  <input type="text" class="form-control form-control-inline" :class="{ 'is-invalid': Check_address }"
                    v-model="form.address[3]" alt="ch" maxlength="50" @input="checkInputAddress"
                    @blur="checkInputAddress" />
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">公司地址</label>
              <div class="col-9">
                <!-- <input type="text" class="form-control form-control-inline form-short" v-model="form.office_address[0]"> -->
                <select class="form-control form-control-inline" v-model="form.office_address[1]"
                  @change="changeCity(form.office_address[1], form.office_address[2].name, 'office_address')"
                  :class="{ 'is-invalid': Check_office_city }">
                  <option value="">請選擇</option>
                  <option v-for="(city, cid) in officeCityOpt" :key="`city-item-${cid}`" :value="city">{{ city }}
                  </option>
                </select>
                <select class="form-control form-control-inline form-medium" v-model="form.office_address[0]"
                  :disabled="form.office_address[1] == ''" @change="changeOfficeArea($event, 'office_address')"
                  :class="{ 'is-invalid': Check_office_area }">>
                  <option value="">請選擇</option>
                  <option v-for="(area, aid) in officeAreaOpt" :key="`area-item-${aid}`" :value="area.no">{{ area.name
                  }}
                  </option>
                </select>
                <input type="text" class="form-control form-control-inline"
                  :class="{ 'is-invalid': Check_office_address }" v-model="form.office_address[3]" alt="ch"
                  maxlength="50" @input="checkInputOfficeAddress" @blur="checkInputOfficeAddress" />
              </div>
            </div>


            <div class="form-group row mt-3">
              <label for="gender-1" class="col-3 text-right"></label>
              <div class="col-9">
                <div class="checkbox checkbox-inline">
                  <input type="checkbox" id='confirm_checkbox' v-model="confirm_checkbox">
                  <label class="text-red custom-label"
                    for="confirm_checkbox">已確實向客戶(潛在客戶)進行個資告知聲明，並留存同意佐證備查，再建立客戶保單資料／進行資料編輯。</label>
                </div>
              </div>
            </div>

            <div class="action text-right">
              <a @click="$emit('close')" class="btn btn-default">
                取消
              </a>
              <a @click.prevent="handleNew()" class="btn btn-primary">
                儲存
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { commonMixin } from "@/mixins/common";
import { queryDistByCity, computeAge, queryIAACust } from '../../service'

export default {
  name: 'ContactInfoModal',
  mixins: [commonMixin],
  props: {
    compName: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    inputs: {
      type: Object,
      default: null
    },
    isRelation: {
      type: Boolean,
      default: false
    },
    // addressData: {
    //   type: Object,
    //   default: () => {
    //     return {};
    //   }
    // },
  },
  watch: {
    open: async function (val) {
      this.confirm_checkbox = false
      if (val) {
        await this.queryNewInfo()
        if (
          this.addressData &&
          this.addressData.feeAdd &&
          this.addressData.feeAdd[3]
        ) {
          this.addressData.feeAdd[3] = this.full2half(
            this.addressData.feeAdd[3]
          );
        }
        this.openContactInfoWindow(val);
        this.registerHanlink();
      }
    },
    'form.lineid': function () {
      this.form.lineid = this.form.lineid.replace(/[^0-9a-zA-Z_\-.@/]+/g, "")
    },
    'form.ID': function () {
      if (this.form.ID) {
        this.form.ID = this.form.ID.toUpperCase();
      }
      this.form.ID = this.form.ID.replace(/[^0-9a-zA-Z*]+/g, "")
    },
    'form.wg_name': function () {  //    原住民姓名(拼音)不能輸入中文
      this.form.wg_name = this.form.wg_name.replace(/[\u4e00-\u9fa5]/g, "")
    }
  },
  computed: {
    ...mapGetters([
      'Cities', 'UserInfo', 'CustInfo'
    ]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === 'box'
    }
  },
  data() {
    return {
      today: window.moment(),
      agedisable: false,
      birthYearOpt: [],
      birthMonthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      birthDateOpt: [],
      cityOpt: [],
      officeCityOpt: [],
      areaOpt: [],
      officeAreaOpt: [],
      Check_city: false,
      Check_area: false,
      Check_address: false,
      Check_office_city: false,
      Check_office_area: false,
      Check_office_address: false,
      isBirdayError: false,
      form: {
        lv: 0,
        familyLeader: false,
        name: '',
        gender: 0,
        birthdayAry: ['', '', ''],
        birthday: '',
        mobile: '',
        phone: ['', ''],
        fax: ['', ''],
        ID: '',
        serNo: '',
        office_phone: ['', '', ''],
        address: ['', '', { name: '', no: '' }, ''],
        office_address: ['', '', { name: '', no: '' }, ''],
        lineid: '',
        wg_name: '',
        age: ''
      },
      mobile_bak: "",
      address_bak: ['', '', '', ''],
      feeAdd_bak: ['', '', '', ''],
      mobile_change: false,
      address_change: false,
      is_same_mobile: true,
      is_same_address: true,
      confirm_checkbox: false,
      Loading: false,
      addressData: {}
    }
  },
  methods: {
    async queryNewInfo() {
      //查詢IAA的資訊
      let agID = this.UserInfo.id || this.$store.state.userInfo.id || "";
      let custID = this.CustInfo.ID || this.$store.state.custInfo.ID || "";
      await queryIAACust(agID, custID, "queryAPI").then(result => {
        if (result.body) {
          let hasDetail = result.body.detail;
          this.addressData = {
            //手機號碼一
            mobile01: hasDetail ? hasDetail.mobl_no || "" : "",
            //收費地址
            feeAdd: hasDetail
              ? [
                hasDetail.addr_p_postal_cd
                  ? hasDetail.addr_p_postal_cd.trim().substring(0, 3)
                  : "",
                hasDetail.addr_p_city_nm
                  ? hasDetail.addr_p_city_nm.trim()
                  : "",
                hasDetail.addr_p_line_1 ? hasDetail.addr_p_line_1.trim() : "",
                hasDetail.addr_p_line_2 ? hasDetail.addr_p_line_2.trim() : ""
              ]
              : ["", "", "", ""]
          };
        }
        this.registerHanlink(); //難字
      });
    },
    //檢查姓名
    checkInputName() {
      this.form.name = this.form.name.replace(/[<>!@#$^&,."'?%*;_()+-/{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.form.name, false, 50) > 50) {
        this.form.name = this.form.name.substring(0, this.stringBytes(this.form.name, true, 50));
      }
    },
    //檢查原住民姓名(拼音)
    checkInputWgName() {
      this.form.wg_name = this.form.wg_name.replace(/[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.form.wg_name, false, 100) > 100) {
        this.form.wg_name = this.form.wg_name.substring(0, this.stringBytes(this.form.wg_name, true, 100));
      }
    },
    //檢查現居地址
    checkInputAddress() {
      this.form.address[3] = this.full2half(this.form.address[3]);
      this.form.address[3] = this.form.address[3].replace(/[<>()^︿!@#$^&,."'?%*:;+_/{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.form.address[3], false, 50) > 50) {
        this.form.address[3] = this.form.address[3].substring(0, this.stringBytes(this.form.address[3], true, 50));
      }
    },
    //檢查公司地址
    checkInputOfficeAddress() {
      this.form.office_address[3] = this.full2half(this.form.office_address[3]);
      this.form.office_address[3] = this.form.office_address[3].replace(/[<>()^︿!@#$^&,."'?%*:;+_/{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.form.office_address[3], false, 50) > 50) {
        this.form.office_address[3] = this.form.office_address[3].substring(0, this.stringBytes(this.form.office_address[3], true, 50));
      }
    },
    //全形轉化為半形
    full2half(str) {
      let result = "";
      let len = str.length;
      for (let i = 0; i < len; i++) {
        let cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248(十進位制)
        if (cCode >= 65281 && 65374 >= cCode) {
          cCode -= 65248;
        } else if (cCode == 12288) { // 全形空白轉半形
          cCode = 32;
        }
        result += String.fromCharCode(cCode);
      }
      return result;
    },
    //  監聽input 只能輸入數字
    numberMobile() {
      this.form.mobile = this.form.mobile.replace(/[^\d]/g, '');
    },
    numberPhone0() {
      this.form.phone[0] = this.form.phone[0].replace(/[^\d]/g, '');
    },
    numberPhone1() {
      this.form.phone[1] = this.form.phone[1].replace(/[^\d]/g, '');
    },
    numberOffice_phone0() {
      this.form.office_phone[0] = this.form.office_phone[0].replace(/[^\d]/g, '');
    },
    numberOffice_phone1() {
      this.form.office_phone[1] = this.form.office_phone[1].replace(/[^\d]/g, '');
    },
    numberOffice_phone2() {
      this.form.office_phone[2] = this.form.office_phone[2].replace(/[^\d]/g, '');
    },
    numberAge() {
      this.form.age = this.form.age.replace(/[^\d]/g, '');
    },
    openContactInfoWindow(val) {
      if (val) {
        this.form.lv = this.inputs.lv;
        this.form.name = this.inputs.name
        this.form.gender = this.inputs.gender
        this.form.age = this.inputs.age
        if (this.inputs.birthday && this.inputs.birthday.trim() != '') {
          this.form.birthdayAry = [Number(this.inputs.birthday.slice(0, 4)), Number(this.inputs.birthday.slice(5, 7)), Number(this.inputs.birthday.slice(8, 10))]
          this.form.birthday = this.inputs.birthday
          this.agedisable = true
        } else {
          this.form.birthdayAry = ['', '', '']
          this.form.birthday = ''
        }
        this.form.mobile = this.inputs.mobile
        this.form.phone = [...this.inputs.phone]
        this.form.fax = this.inputs.fax
        this.form.ID = this.inputs.ID
        this.form.serNo = this.inputs.serNo
        this.form.office_phone = [...this.inputs.office_phone]

        // 同步地址區碼及名稱
        // this.form.address = [this.inputs.address[0], this.inputs.address[1], {no: this.inputs.address[0].trim(), name: this.inputs.address[2].trim()}, this.inputs.address[3]]
        this.form.address = [this.inputs.address[0], this.inputs.address[1], { no: '', name: '' }, this.inputs.address[3]]

        // this.form.office_address = [this.inputs.office_address[0], this.inputs.office_address[1], {no: this.inputs.office_address[0].trim(), name: this.inputs.office_address[2].trim()}, this.inputs.office_address[3]]
        this.form.office_address = [this.inputs.office_address[0], this.inputs.office_address[1], { no: '', name: '' }, this.inputs.office_address[3]]

        this.form.wg_name = this.inputs.wg_name
        this.form.lineid = this.inputs.lineid
        this.updateDate()

        if (this.inputs.address && this.inputs.address[1]) {
          this.changeCity(this.inputs.address[1], this.inputs.address[2], 'address', false, true)
        } else {
          this.clear();
          this.checkSame();
        }

        if (this.inputs.office_address && this.inputs.office_address[1]) {
          this.changeCity(this.inputs.office_address[1], this.inputs.office_address[2], 'office_address', false, true)
        }

        //檢查現居地址與公司地址欄位的初始查回資料
        this.checkFormAddrAndFormOfficeAddr();

      }
    },
    checkName() {
      // 不能空 也不能為特殊符號
      let pattern = /[<>!@#$^&,."'?%*;_()+-/{}[\]|~`=\\\s]/g
      let isNonEmpty = this.form.name.trim().length > 0
      let isFormatCurrect = (this.form.name.match(pattern) == null)
      return isNonEmpty && isFormatCurrect
      // return true
    },
    checkWgName() {
      // if(this.form.wg_name == '') {return true}
      // let wgNamePattern = /^[a-zA-Z\s\:\넖\넗\넘\넙\넚\넛]+$/
      //big5編碼 A88F , A890 , A891 , A892 , A893 , A894
      // return wgNamePattern.test(this.form.wg_name)
      return true
    },
    checkSexById() {
      if (this.form.ID.length > 1) {
        var sexOfId = this.form.ID.substr(1, 1)
        if (sexOfId.toUpperCase().match("1|8|A|C")) {
          this.form.gender = '1'
        } else if (sexOfId.toUpperCase().match("2|9|B|D")) {
          this.form.gender = '2'
        }
      }
    },
    checkLine() {
      if (this.form.lineid == '') { return true }
      let linePattern = /^[A-Za-z0-9@_\-./]+$/
      return linePattern.test(this.form.lineid)
    },
    checkMobile() {
      if (this.form.mobile == '') { return true }
      let mobilePattern = new RegExp('^[0-9]{10}$')
      return mobilePattern.test(this.form.mobile)
    },
    checkPhone(target) {
      let phoneAreaPattern = new RegExp('^0[0-9]{1,4}$')
      let phonePattern = new RegExp('^[0-9]{4,20}$')
      let extPattern = /^[0-9]{0,10}$/
      switch (target) {
        case 'home':
          if (this.form.phone[0] == '' && this.form.phone[1] == '') { return true }
          return phoneAreaPattern.test(this.form.phone[0]) && phonePattern.test(this.form.phone[1])
        case 'office':
          if (this.form.office_phone[0] == '' && this.form.office_phone[1] == '' && this.form.office_phone[2] == '') { return true }
          return phoneAreaPattern.test(this.form.office_phone[0]) && phonePattern.test(this.form.office_phone[1]) && extPattern.test(this.form.office_phone[2])
        default:
          return false
      }
    },
    checkAddr() { //確認地址是不是有特殊字元
      let addr = true
      let addrOffice = true
      let pattern = /[<>!@#$^&,."'?%*:;+_/{}[\]|~`=\\\s]/g
      if (this.form.address[3]) {
        addr = this.form.address[3].match(pattern) == null
      }
      if (this.form.office_address[3]) {
        addrOffice = this.form.office_address[3].match(pattern) == null
      }
      return addr && addrOffice
    },
    checkWordLimit() { // 檢查欄位字數
      if (this.form.name.length > 50 || this.form.wg_name.length > 100 ||
        this.form.ID.length > 10 || this.form.lineid.length > 20 || this.form.mobile.length > 20 ||
        this.form.phone[0].length > 5 || this.form.phone[1].length > 20 || this.form.office_phone[0].length > 5 ||
        this.form.office_phone[1].length > 15 || this.form.office_phone[2].length > 10 ||
        this.form.address[3].length > 50 || this.form.office_address[3].length > 50) {
        return true
      } else {
        return false
      }
    },
    checkContactInfoIsAllEmpty() {
      let isLineEmpty = this.form.lineid == ''
      let isMobileEmpty = this.form.mobile == ''
      let isPhoneEmpty = this.form.phone[0] == '' && this.form.phone[1] == ''
      let isOfficePhoneEmpty = this.form.office_phone[0] == '' && this.form.office_phone[1] == '' && this.form.office_phone[2] == ''
      return isLineEmpty && isMobileEmpty && isPhoneEmpty && isOfficePhoneEmpty
    },
    checkBirthdayAgeAllEmpty() {
      let isAgeEmpty = this.form.age == ''
      let isBirthdayEmpty = this.form.birthdayAry[0] == '' || this.form.birthdayAry[1] == '' || this.form.birthdayAry[2] == ''
      return isBirthdayEmpty && isAgeEmpty
    },
    checkFormAddrAndFormOfficeAddr() {
      let cityInput = this.form.address[1];
      let roadInput = this.form.address[3];
      let isValidCityArr = this.cityOpt.filter(city => cityInput === city)

      let officeCityInput = this.form.office_address[1];
      let officeRoadInput = this.form.office_address[3];
      let isValidOfficeCityArr = this.officeCityOpt.filter(officeCity => officeCityInput === officeCity)

      if (isValidCityArr.length == 0 && roadInput == '') {
        this.form.address[1] = ''
      }

      if (isValidOfficeCityArr.length == 0 && officeRoadInput == '') {
        this.form.office_address[1] = ''
      }

    },
    computeBirAge(year, month, day) {  // 計算保險年齡
      this.isBirdayError = false;
      if (year !== '' && month !== '' && day !== '') {
        this.form.age = ''
        if (month < 10) {
          month = "0" + month
        }
        if (day < 10) {
          day = "0" + day
        }
        computeAge(this.$store.state.userInfo.id, `${year}-${month}-${day}`).then(result => {
          if (result.header && result.header.status == '200') {
            this.form.age = result.body.age
          } else {
            this.form.age = '計算錯誤'
          }
        })
        this.agedisable = true
        this.form.age = '計算中...'
      } else {
        this.form.age = ''
        this.agedisable = false
      }
      this.updateDate()
    },
    //檢核
    handleNew() {
      if (this.form.address[3].trim().length > 0) {
        this.Check_address = false;
        //居家沒有選市
        if (this.form.address[1].trim().length == 0) {
          this.Check_city = true;
        } else {
          //有選市沒有選區
          if (!this.form.address[2]) {
            this.Check_city = false;
            this.Check_area = true;
          } else {
            this.Check_city = false;
            this.Check_area = false;
          }
        }
      } else if (this.form.address[1].trim().length > 0) {
        this.Check_city = false;
        if (this.form.address[3].trim().length == 0 && !this.form.address[2]) {
          this.Check_address = true;
          this.Check_area = true;
        } else {
          //有選區沒有地址
          if (this.form.address[2] && this.form.address[3].trim().length == 0) {
            this.Check_area = false;
            this.Check_address = true;
          }
        }
      } else {
        this.Check_city = false;
        this.Check_area = false;
        this.Check_address = false;
      }
      //公司沒有選市
      if (this.form.office_address[3].trim().length > 0) {
        this.Check_office_address = false;
        //居家沒有選市
        if (this.form.office_address[1].trim().length == 0) {
          this.Check_office_city = true;
        } else {
          //有選市沒有選區
          if (!this.form.office_address[2]) {
            this.Check_office_city = false;
            this.Check_office_area = true;
          } else {
            this.Check_office_city = false;
            this.Check_office_area = false;
          }
        }
      } else if (this.form.office_address[1].trim().length > 0) {
        this.Check_office_city = false;
        if (this.form.office_address[3].trim().length == 0 && !this.form.office_address[2]) {
          this.Check_office_address = true;
          this.Check_office_area = true;
        } else {
          //有選區沒有地址
          if (this.form.office_address[2] && this.form.office_address[3].trim().length == 0) {
            this.Check_office_area = false;
            this.Check_office_address = true;
          }
        }
      } else {
        this.Check_office_city = false;
        this.Check_office_area = false;
        this.Check_office_address = false;
      }

      //若全部為空值，檢核可通過。
      if (this.Check_city == true || this.Check_area == true || this.Check_address == true || this.Check_office_city == true || this.Check_office_area == true || this.Check_office_address == true) {
        this.$toast.info({ title: '請填寫完整地址' });
        return;
      } else {
        this.submit();
      }

    },
    submit() {
      if (this.checkWordLimit()) {    // 檢查欄位字數
        return this.$toast.info({ title: '欄位字數超過限制' })
      }
      let checkNameMsg = this.checkName() ? '' : '姓名不能為空不能有特殊符號'
      let checkWgNameMsg = this.checkWgName() ? '' : '原住民名不能為空不能有特殊符號'
      let checkAddrMsg = this.checkAddr() ? '' : '地址不能有特殊字元或空白字元'
      let checkLineMsg = this.checkLine() ? '' : 'line不能有特殊字元或空白字元'
      let checkMobileMsg = this.checkMobile() ? '' : '手機格式有誤'
      let checkHomePhoneMsg = this.checkPhone('home') ? '' : '住家電話格式有誤'
      let checkOfficePhoneMsg = this.checkPhone('office') ? '' : '公司電話格式有誤'
      //let checkBirthdayAgeMsg =  this.checkBirthdayAgeAllEmpty()? '生日或年齡不能全為空': ''
      //let checkContactInfoMsg = this.checkContactInfoIsAllEmpty()? '聯絡資訊不能全為空': ''
      let toastMsg = [checkNameMsg, checkWgNameMsg, checkAddrMsg, checkLineMsg, checkMobileMsg
        , checkHomePhoneMsg, checkOfficePhoneMsg].filter(msg => { return msg != '' }).join(',')

      if (toastMsg == '') {
        let month = this.form.birthdayAry[1].toString().length == 1 ? '0' + this.form.birthdayAry[1].toString() : this.form.birthdayAry[1].toString()
        let date = this.form.birthdayAry[2].toString().length == 1 ? '0' + this.form.birthdayAry[2].toString() : this.form.birthdayAry[2].toString()
        let birthday = [this.form.birthdayAry[0].toString(), month, date].join('-')
        const birthdayRegex = /\d{4}\-\d{2}\-\d{2}/g
        if (!birthdayRegex.test(birthday)) {
          birthday = ''
        }
        //檢核生日
        if (birthday && !moment(birthday).isSameOrBefore(moment(), "day")) {
          this.$toast.info({ title: "出生日期不得超過今日" });
          this.isBirdayError = true;
          return false;
        }

        if (!this.confirm_checkbox) {
          this.$toast.info({ title: '未經客戶同意編輯資料' })
          return
        }

        this.form.birthday = birthday
        let custInfo = Object.assign({}, this.form)

        if (this.form.address[2] === '') {
          custInfo.address[0] === ''
          custInfo.office_address[0] === ''
        } else {
          custInfo.address[2] = this.form.address[2] ? this.form.address[2].name : '';
          custInfo.office_address[2] = this.form.office_address[2] ? this.form.office_address[2].name : '';
        }

        //恢復custInfo郵遞區號
        if ('新竹市' === custInfo.address[1])
          custInfo.address[0] = 300
        else if ('嘉義市' === custInfo.address[1])
          custInfo.address[0] = 600

        if ('新竹市' === custInfo.office_address[1])
          custInfo.office_address[0] = 300
        else if ('嘉義市' === custInfo.office_address[1])
          custInfo.office_address[0] = 600

        this.$emit('submit', custInfo)

      } else {
        this.$toast.info({ title: toastMsg })
      }
    },
    updateDate() {
      let yaer = this.form.birthdayAry[0]
      let month = this.form.birthdayAry[1]
      if (!yaer || !month) return

      //let dt = window.moment().year(yaer).month(month - 1).endOf('month')
      let dt = new Date(yaer, month, 0).getDate()
      this.birthDateOpt = []
      for (var i = 0; i < dt; i++) {
        this.birthDateOpt.push(i + 1)
      }

      let month2 = this.form.birthdayAry[1].toString().length == 1 ? '0' + this.form.birthdayAry[1].toString() : this.form.birthdayAry[1].toString()
      let date = this.form.birthdayAry[2].toString().length == 1 ? '0' + this.form.birthdayAry[2].toString() : this.form.birthdayAry[2].toString()
      this.form.birthday = [this.form.birthdayAry[0].toString(), month2, date].join('-')

      if ("function" === typeof (parseEUDC)) {
        parseEUDC("ap");
      }
    },
    initAreaData(target) {   // 清除郵遞區號跟地址
      if (target === 'address') {
        this.form.address[0] = ''
        this.form.address[2] = {
          name: '',
          no: ''
        }
        // this.form.address[3] = ''
      } else if (target === 'office_address') {
        this.form.office_address[0] = ''
        this.form.office_address[2] = {
          name: '',
          no: ''
        }
        // this.form.office_address[3] = ''
      }

    },
    changeCity(key, area, target, init = true, isOpen = false) {
      // 取得郵遞區號與分區
      queryDistByCity(this.$store.state.userInfo.id, key).then(result => {
        if (result) {
          // 住家地址
          if (target == 'address') {
            if (result.body && result.body.cityAreaList && result.body.cityAreaList.length > 0) {
              if (init) {  // 初始化清空區域
                this.form.address[2] = { no: '', name: '' }
              }

              this.areaOpt = result.body.cityAreaList.map(item => {
                return {
                  no: item.ZIPCODE,
                  name: item.AREA
                }
              })

              // 為避免郵遞區號相同時選取的問題，進行指定不同區號處理(新竹市、嘉義市)
              let cityName = result.body.cityAreaList[0].CITY
              if ('新竹市' === cityName || '嘉義市' === cityName) {
                let zipCode = this.getZipCode(cityName);
                this.areaOpt.forEach((item, index) => {
                  let tempZipCode = zipCode + (index + 1)

                  this.areaOpt[index].no = tempZipCode //指定各區區號 = 原郵遞區號 + (index+1)

                  if (item.name === area)
                    this.form.address[0] = tempZipCode
                })
              }

              if (isOpen) {  //  如果是開啟 modal 設定區域
                if (this.inputs.address[0].trim() !== '' || (this.inputs.address[2].trim() !== '')) {
                  this.areaOpt.forEach(item => {
                    // if(item.name.trim() == this.inputs.address[2].trim() && item.no.trim() == this.inputs.address[0].trim()) {
                    //   this.form.address[2] = {no: item.no, name: item.name}
                    // }
                    if (item.name.trim() == this.inputs.address[2].trim()) {
                      this.form.address[2] = { no: item.no, name: item.name }
                    }
                  })
                } else { this.form.address[2] = { no: '', name: '' } }
                this.clear();
                this.checkSame();
              } else {
                this.form.address[0] = ''
              }

            } else {
              this.areaOpt = []
            }
          } else {  // 公司地址
            if (result.body && result.body.cityAreaList && result.body.cityAreaList.length > 0) {
              if (init) {  // 初始化清空區域
                this.form.office_address[2] = { no: '', name: '' }
              }
              this.officeAreaOpt = result.body.cityAreaList.map(item => {
                return {
                  no: item.ZIPCODE,
                  name: item.AREA
                }
              })
              // 為避免郵遞區號相同時選取的問題，進行指定不同區號處理(新竹市、嘉義市)
              let cityName = result.body.cityAreaList[0].CITY
              if ('新竹市' === cityName || '嘉義市' === cityName) {
                let zipCode = this.getZipCode(cityName);
                this.officeAreaOpt.forEach((item, index) => {
                  let tempZipCode = zipCode + (index + 1)

                  this.officeAreaOpt[index].no = tempZipCode //各區區號 = 原郵遞區號 + (index+1)

                  if (item.name === area)
                    this.form.office_address[0] = tempZipCode
                })
              }

              if (isOpen) {  //  如果是開啟 modal 設定區域
                if (this.inputs.office_address[0].trim() !== '' || (this.inputs.office_address[2].trim() !== '')) {
                  this.officeAreaOpt.forEach(item => {
                    // if(item.name.trim() == this.inputs.office_address[2].trim() && item.no.trim() == this.inputs.office_address[0].trim()) {
                    //   this.form.office_address[2] = {no: item.no, name: item.name}
                    // }
                    if (item.name.trim() == this.inputs.office_address[2].trim()) {
                      this.form.office_address[2] = { no: item.no, name: item.name }
                    }
                  })
                } else { this.form.office_address[2] = { no: '', name: '' } }
              } else {
                this.form.office_address[0] = ''
              }
            } else {
              this.officeAreaOpt = []
            }
          }
        }
      })
    },
    getZipCode(cityName) {
      if ('新竹市' === cityName)
        return 300
      else if ('嘉義市' === cityName)
        return 600
    },
    changeArea(event, target) {
      let selectedValue = event.target.value
      this.form[target][0] = selectedValue
      this.areaOpt.forEach(area => {
        if (area.no == selectedValue) {
          this.form[target][2].no = selectedValue
          this.form[target][2].name = area.name
        }
      })
    },
    changeOfficeArea(event, target) {
      let selectedValue = event.target.value
      this.form[target][0] = selectedValue
      this.officeAreaOpt.forEach(officeArea => {
        if (officeArea.no == selectedValue) {
          this.form[target][2].no = selectedValue
          this.form[target][2].name = officeArea.name
        }
      })
    },
    stringBytes(c, isSub, size) { //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n = c.length, s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    change(value) {
      if (value == 'mobile') {
        if (this.mobile_change == false) {//代入客戶留存最新手機
          this.mobile_bak = this.form.mobile;
          this.form.mobile = this.addressData.mobile01;
        } else {
          this.form.mobile = this.mobile_bak;
        }
      } else if (value == 'address') {
        if (this.address_change == false) {//代入客戶留存最新地址
          this.queryCity(this.addressData.feeAdd[1])
          this.address_bak = this.form.address;
          this.feeAdd_bak = this.addressData.feeAdd;
        } else {
          this.form.address = this.address_bak;
        }

      }
    },
    checkSame() {
      if (this.isRelation) {
        //比對手機號碼
        if (this.addressData.mobile01 && this.addressData.mobile01.trim()) {
          if (this.form.mobile == this.addressData.mobile01) {
            this.is_same_mobile = true;
          } else {
            this.is_same_mobile = false;
          }
        }
        //比對地址
        if (
          this.addressData.feeAdd &&
          this.addressData.feeAdd[1] &&
          this.addressData.feeAdd[1].trim() &&
          this.addressData.feeAdd[2] &&
          this.addressData.feeAdd[2].trim() &&
          this.addressData.feeAdd[3] &&
          this.addressData.feeAdd[3].trim()
        ) {
          if (
            this.form.address[1] == this.addressData.feeAdd[1] &&
            this.form.address[2]["name"] == this.addressData.feeAdd[2] &&
            this.form.address[3] == this.addressData.feeAdd[3]
          ) {
            this.is_same_address = true;
          } else {
            this.is_same_address = false;
          }
        }
      }
    },
    clear() {
      this.mobile_change = false;
      this.address_change = false;
    },
    queryCity(key) {
      // 取得郵遞區號與分區
      queryDistByCity(this.$store.state.userInfo.id, key).then(result => {
        if (result) {
          if (result.body && result.body.cityAreaList && result.body.cityAreaList.length > 0) {
            this.areaOpt = result.body.cityAreaList.map(item => {
              return {
                no: item.ZIPCODE,
                name: item.AREA
              }
            })
            if (this.addressData.feeAdd[0].trim() !== '' || (this.addressData.feeAdd[2].trim() !== '')) {
              this.areaOpt.forEach(item => {
                if (item.name == this.addressData.feeAdd[2].trim() || item.no == this.addressData.feeAdd[0].trim()) {
                  this.form.address[2] = { no: item.no, name: item.name }
                }
              })
            }
          }
        }
        let a = this.addressData.feeAdd[0];
        let b = this.addressData.feeAdd[1];
        let c = this.addressData.feeAdd[2];
        let d = this.addressData.feeAdd[3];
        this.feeAdd_bak[2] = { no: this.addressData.feeAdd[0], name: this.addressData.feeAdd[2] }
        this.form.address = this.feeAdd_bak;
        this.addressData.feeAdd = [a, b, c, d];
      })
    }
  },
  mounted() {
    let start = this.today.year()
    this.birthYearOpt = Array.apply(null, { length: 101 }).map(function (value, index) { return start - index })

    this.Cities.forEach(ci => {
      this.cityOpt.push(ci.city)
      this.officeCityOpt.push(ci.city)
    })
  }
}
</script>
<style lang="scss" scoped>
.form-control.is-invalid {
  background-image: url('../../../public/assets/common/icon-close-red.svg');
  background-size: 20px 20px;
  background-position: center right 8px;
  background-repeat: no-repeat;
}

.checkbox>input {
  width: 100% !important;
  height: 40px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

.checkbox>input+label.custom-label {
  display: inline-flex;
  align-items: flex-start;

  height: auto;
  line-height: 1.5;

  padding-top: 2px;
  padding-bottom: 5px;
}
</style>
